import { SiteShipToAddressService } from './../../../../../services/modules/common/site-ship-to-address.service';
import { FormatService } from '~/services/administration.ts/format';
import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IAssetPurchaseOrderDto } from '~/models/modules/Asset/Orders/assetPurchaseOrderDto';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { PageState } from '~/shared/enums/stock-files.enum';
import { parseDate } from '@progress/kendo-angular-intl';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { Observable, Subscription } from 'rxjs';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { UserSummary } from '~/models/administration/user';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldSummary } from '~/models/modules/customField';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { SelectEvent, TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { AssetPurchaseOrdersService } from '~/services/modules/assets/orders/asset-purchase-orders.service';
import { AssetModelService } from '~/services/modules/assets/asset-model.service';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { FundingSourceService } from '~/services/modules/assets/fundingSource';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { FundingSourceSettingsService } from '~/services/administration.ts/fundingSourceSettings';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FormTabSummary } from '~/models/modules/formTab';
import { GridFieldSummary } from '~/models/modules/gridField';
import { NoteComponent } from '~/shared/components/note/note.component';
import { ReportsService } from '~/services/modules/reports/reports';
import { ReportViewerPopupComponent } from '~/shared/components/viewer/popup.component';
import { IAssetPurchaseOrderFilesDto } from '~/models/modules/Asset/Orders/assetPurchaseOrderFilesDto';
import { EntityStatusOptions } from '~/models/entityStatus';
import { FilesService } from '~/services/modules/stocks/files';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { fileSources } from '~/shared/enums/fileSources';
import { GDataService } from '~/services/GDataService';
import { AssetPoPreferencesService } from '~/services/administration.ts/asset-po-preferences';
import { AssetPoPreference } from '~/models/administration/AssetPoPreference';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { VendorSummary } from '~/models/modules/vendor';
import { IAssetModelDto } from '~/models/modules/Asset/assetModel';
@Component({
    selector: 'app-asset-purchase-orders-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssetPurchaseOrdersUpsertComponent
  extends MultiSiteAwareComponent
  implements OnInit {
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  _active: boolean = true;
  _showTransactionFieldEditor: boolean = false;
  _transactionsFieldEditorObjectCode: string = ''
  _pageState: PageState;



  _permissionScope = 'asset-purchaseOrders';
  _page = 'asset-purchaseOrders';
  _entity = 'Asset';
  _language = 'en';
  _theme: string;
  _form: FormGroup;
  _model: IAssetPurchaseOrderDto;
  copyModelId: number;
  _customForm: any;
  _gridFieldText: GridFieldTextSummary[];
  _storagePath: string;




  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;
  //#region Vendors Properties
  _showVendorsGrid: boolean = false;
  _selectedVendors: any = [];
  _vendors: any[] = [];
  _vendorsFiltered: any[] = [];
  _vendorsGridColumns: any = [];
  _selectedVendorId: number;
  @ViewChild('kendo_combo_vendors') kendoComboVendors: ComboBoxComponent;
  @ViewChild('textarea_vendoraddress') vendorAddressTextarea: ElementRef;
  //#endregion

  //#region Models Properties
  _showModelsGrid: boolean = false;
  _selectedModels: any = [];
  _models: any[] = [];
  _modelsFiltered: any[] = [];
  _modelsGridColumns: any = [];
  _selectedModelItem = new FormControl();
  _selectedModelItemId: number;
  @ViewChild('kendo_combo_models') kendoComboModels: ComboBoxComponent;
  //#endregion
  //#region Site Ship To Address Properties
  _showAddressGrid: boolean = false;
  _selectedAddresses: any = [];
  _addresses: any[];
  _addressesFiltered: any[];
  _addressesGridColumns: any = [];
  _selectedAddressId: number;
  @ViewChild('kendo_combo_addresses') kendoComboAddresses: ComboBoxComponent;
  @ViewChild('textarea_address') addressTextarea: ElementRef;
  //#endregion
  //#region Funding Sources Properties
  _showFundingSourceGrid: boolean = false;
  _selectedFundingSources: any = [];
  _fundingSources: any[] = [];
  _fundingSourcesFiltered: any[] = [];
  _fundingSourcesGridColumns: any = [];
  _selectedFundingSourceId: number;
  _fundingSourceSettingsEnabled: boolean = false;
  @ViewChild('kendo_combo_fundingSources') kendo_combo_fundingSources: ComboBoxComponent;
  //#endregion

  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;



  _currentUser: UserSummary;
  _selectedCallback = (args: { dataItem: any }) => args.dataItem;
  _gridFieldAuth: GridFieldAuthorization[];
  _datePickerFormat: string;
  _costFormat: string;
  _minDate: Date = new Date(1901, 1, 1);
  _isNew: boolean = true;

  isGeneralInformationExpanded: boolean = true;
  isScanInventoryExpanded: boolean = true;
  _invalidForm: boolean;
  showReports: boolean = false;
  _selectedAccountIds: any[] = [];
  _invalidSubmit: boolean;

  _subtotal: number = 0;
  _shipping: number = 0;
  _discount: number = 0;
  _otherAdjustment: number = 0;
  _tax: number = 0;
  _total: number = 0;
  quantityFormat: string;
  digitNumber: number;
  assetPurchaseOrder: any;
  _modelsGridData: any = [];
  _innerWidth: any;


  _hiddenWindow: any;
  _maximized: any;
  _isOs: boolean;

  _approvalCycleEnabled: boolean = false;
  _submitted: boolean = false;
  _isCreator: boolean = false;
  _isFirstApprover: boolean = false;
  _isSecondApprover: boolean = false;

  _firstApprovalEnabled: boolean = false;
  _firstApprovalStatus: string = 'pending';

  _secondApprovalEnabled: boolean = false;
  _secondApprovalStatus: string = 'pending';

  _approvalCycleState: string = 'completed';

  _isPendingFirstApproval: boolean = false;
  _isPendingSecondApproval: boolean = false;

  reloadlist: any;

  _defaultQuantity = new FormControl();
  _defaultUnitCost = new FormControl();
  _quantity = new FormControl();
  _unitCost = new FormControl();



  // _poNumber = new FormControl();

  pageState = PageState; // For Using Enum in Html
  _isAnyItemReceived: boolean = false;
  _selectedAccounts: any[] = [];

  // #region Popup Statuses
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _isEditForms: boolean = false;
  _selectedTabId: number;
  _selectedLabelId: number;
  _deactivatedFieldsGridData: any[] = [];
  // #endregion
  // #region Tab Containers
  _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<FormTabSummary> = [];
  _dataTabsSelected: Array<FormTabSummary> = [];
  _userNewDataTabs: Array<FormTabSummary> = [];
  _customTabs: any;
  _tabDisabledIndexes: number[] = [];
  // #endregion
  // #region Custom Fields / Edit Form
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: string;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _custominvalidForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  requiredSystemTabs: any = [];
  _requiredFieldNames: any = [];
  _requiredFields: any = [];
  _additionalErrors: any = [];

  _customFields: CustomFieldSummary[][] = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _customFieldsValue: any[] = [];
  _customValidation: any = [];
  _systemFields: GridFieldSummary[] = [];
  _editedSystemFields: any = [];
  // #endregion
  //#region Asset Po Preference Settings
  _assetPoPreferencesSettings: AssetPoPreference;
  //#endregion
  // #region Videos/Documents/Pictures
  _filesPageName: string = 'files';
  _documentsPageName: string = 'documents'
  _videosPageName: string = 'videos'
  _imageSearchControl = new FormControl();
  _documentSearchControl = new FormControl();
  _videoSearchControl = new FormControl();
  _showImagesGrid: boolean = false;
  _showDocumentsGrid: boolean = false;
  _showVideoGrid: boolean = false;
  _imageSearchResult: string;
  _documentSearchResult: string;
  _videoSearchResult: string;
  _filesGridFields: GridFieldSummary[];
  _documentsGridFields: GridFieldSummary[];
  _videosGridFields: GridFieldSummary[];
  _filesGridFieldsSub!: Subscription;
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _selectedDocumentsKeys: number[] = [];
  _selectedVideos: any[] = [];
  _selectedVideosKeys: number[] = [];
  _purchaseOrderFilesPics: IAssetPurchaseOrderFilesDto[] = [];
  _purchaseOrderFilesDoc: IAssetPurchaseOrderFilesDto[] = [];
  _purchaseOrderFilesVideo: IAssetPurchaseOrderFilesDto[] = [];
  _selectedObjectImages: any[] = [];
  _selectedObjectDocuments: any[] = [];
  _selectedObjectVideos: any[] = [];
  _selectedUpsertImagesKeys: number[] = [];
  // #endregion

  //#region Print Action Fields
  assetPurchaseOrderReports: any;
  @ViewChild('kendo_combo_Receipt_Report') selectReceiptReport: ComboBoxComponent;
  //#endregion
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;

  @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('unitcost_input') unitCostInput: NumericTextBoxComponent;
  @ViewChild('po_input') poInput: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;
  @ViewChild('note') note: NoteComponent;
  _note: string;
  //#region Multi Site Variables

  //#endregion
  _showVendorFileNotes: boolean = false;
  _vendorNotesModel: VendorSummary;

  _showModelFileNotes: boolean = false;
  _modelNotesModel: IAssetModelDto;
  constructor(
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _fb: FormBuilder,
    private _gridFields: GridFieldsService,
    private _vendorsService: VendorsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _formatService: FormatService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private quantityFormatsService: QuantityFormatsService,
    private _assetPurchaseOrderService: AssetPurchaseOrdersService,
    private _assetModelService: AssetModelService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _fundingSourceService: FundingSourceService,
    private _fundingSourceSettingService: FundingSourceSettingsService,
    private _customFieldsService: CustomFieldsService,
    private _reportService: ReportsService,
    private _dataService: GDataService,
    private _filesService: FilesService,
    private _siteShipToAddress: SiteShipToAddressService,
    private _assetPoPreferencesService: AssetPoPreferencesService,
    private _multiSitesService: MultiSiteService
  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }
  ngOnInit(): void {
    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';
    this.getdata();
    this.loadDropDowns();
    this.GetFundingSourceSettings();
    this.GetAssetPoPreferenceSettings();
    this._initForm();
    //#region Get Current User
    this._currentUser = this._securityService.currentUser;
    if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites =
        localStorage.getItem('loggedInAccountSites') ?? '';
      if (loggedInAccountSites != '') {
        this._form.patchValue({
          account: {
            id: JSON.parse(loggedInAccountSites)[0].accountId,
            name: '',
          },
          //site: { id: JSON.parse(loggedInAccountSites)[0].siteId, name: '' },
        });

      }
    }
    //#endregion
    this.getAuth();
    this.loadLabels();
    this.getFormTabs();
    this.getSystemFieldsAndCustomFields();
    this._getInactiveFields();
    //#region Add From Popup
    this._vendorsService.vendorAdded.subscribe(x => {
      if (x.siteId == this._form.controls['site'].value?.id || !x.siteId) {
        this._vendors.push(x);
        this._vendorsFiltered = this._vendors;

        this._form.controls['vendor'].setValue(x);
        this._handleVendorsChange(x, false);
      }

    })
    this._vendorsService.vendorUpdated.subscribe(vendor => {
      var UpdatedRecord = this._vendors.find(x => x.id == vendor.id);
      if (UpdatedRecord) {
        var Index = this._vendors.indexOf(UpdatedRecord);
        this._vendors[Index] = vendor;
      }
      this._form.controls['vendor'].setValue(vendor);
      this._handleVendorsChange(vendor, false);
    })
    this._fundingSourceService.fundingSourceAdded.subscribe(x => {

      this._fundingSources.push(x);
      this._fundingSourcesFiltered = this._fundingSources;
      this._form.controls['fundingSource'].setValue(x);
      this._handleFundingSourcesChange(x);
    })
    //#endregion
    //#region Grid Fields For Popups

    this._gridFields
      .getGridFieldsByPage('vendors')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('vendors', data);
      });

    this.registerSubscription(
      this._gridLayoutManagerService.subscribeToColumnsChanges(
        'vendors',
        (gridColumns) => {
          this._vendorsGridColumns = gridColumns;
        }
      )
    );
    this._gridFields
      .getGridFieldsByPage('asset-models')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'asset-models',
          data
        );
      });

    this.registerSubscription(
      this._gridLayoutManagerService.subscribeToColumnsChanges(
        'asset-models',
        (gridColumns) => {
          this._modelsGridColumns = gridColumns;
        }
      )
    );
    this._gridFields
      .getGridFieldsByPage('fundingsource')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(
          'fundingsource',
          data
        );
      });

    this.registerSubscription(
      this._gridLayoutManagerService.subscribeToColumnsChanges(
        'fundingsource',
        (gridColumns) => {
          this._fundingSourcesGridColumns = gridColumns;
        }
      )
    );


    //#endregion

    //#region Custom Formats
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this.LoadQuantityFormats();

    //#endregion
    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.isAttachment == true) {
        if ((str?.response && str.component == 'files')) {
          this._addPicture(str);
        }
        if (str?.response && str.component == 'documents') {
          this._addDocument(str);
        }
        if (str?.response && str.component == 'videos') {
          this._addVideo(str);
        }
      }
    })
  }
  ngAfterViewInit() {
    if (this._model.vendor)
      this._handleVendorsChange(this._model.vendor, false);
    if (this._model.address)
      this._handleAddressesChange(this._model.address);
    if (this._model.fundingSource)
      this._handleFundingSourcesChange(this._model.fundingSource);
  }
  getdata(afterSave: boolean = false) {
    if (!afterSave) {
      this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
      this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    }

    this._purchaseOrderFilesPics = [];
    this._purchaseOrderFilesDoc = [];
    if (this._model?.assetPurchaseOrderFiles) {
      this._model.assetPurchaseOrderFiles.forEach((element: any) => {
        if (element.file?.type.includes('image')) {
          this._purchaseOrderFilesPics.push(element);
        }
        else if (element.file?.type.includes('application')) {
          this._purchaseOrderFilesDoc.push(element);
        }
        else if (element.file?.type.includes('video')) {
          this._purchaseOrderFilesVideo.push(element);
        }
      });
    }
    if (this._model && this._pageState == PageState.ADD) {
      this.copyModelId = this._model.id; // for loading custom fields data if there is any
    }
    if (this._model?.id)
      this._isNew = false;
    else
      this._isNew = true;
    //#region Approval Cycle
    if (this._model.vendorHasApprovalCycle) {
      this._approvalCycleEnabled = this._model.approvalCycleEnabled;
      this._submitted = (this._model.assetPurchaseOrderStatusId != null && this._model.assetPurchaseOrderStatusId == 1
        || this._model.assetPurchaseOrderStatusId == 6) ? false : true;

      this._isCreator = this._model.isCreator;
      this._isFirstApprover = this._model.isFirstApprover;
      this._isSecondApprover = this._model.isSecondApprover;

      this._firstApprovalEnabled = this._model.firstApprovalEnabled;
      this._firstApprovalStatus = this._model.firstApprovalStatus;

      this._secondApprovalEnabled = this._model.secondApprovalEnabled;
      this._secondApprovalStatus = this._model.secondApprovalStatus;

      this._isPendingFirstApproval = this._model.isPendingFirstApproval;
      this._isPendingSecondApproval = this._model.isPendingSecondApproval;

      this._approvalCycleState = this._model.approvalCycleState;
      this.assetPurchaseOrder = this._model;
    }
    //#endregion
    this._subtotal = this._model.subtotal ?? 0;
    this._shipping = this._model.shipping ?? 0;
    this._discount = this._model.discount ?? 0;
    this._otherAdjustment = this._model.otherAdjustment ?? 0;
    this._tax = this._model.tax ?? 0;
    this._total = this._model.total ?? 0;
    if (this._model != null && this._model.assetPurchaseOrderDetails != null && !afterSave) {
      this._model.assetPurchaseOrderDetails.forEach((item: any) => {

        this._modelsGridData.push({
          modelId: item.modelId,
          id: item.id,
          assetPurchaseOrderId: item.assetPurchaseOrderId,
          quantityReceived: item.quantityReceived,
          backorderQty: (item.quantity ? item.quantity : 0) - (item.quantityReceived ? item.quantityReceived : 0),
          modelNumber: item.model?.number,
          modelName: item.model?.name,
          quantity: item.quantity,
          unitCost: item.unitCost,
          extendedCost: item.extendedCost,
          isTaxable: item.isTaxable,
        });
      });
      var QuantityReceived = this._modelsGridData.find((x: any) => x.quantityReceived > 0);
      if (QuantityReceived)
        this._isAnyItemReceived = true;
    }
    // var loggedInAccountSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));

    // if (loggedInAccountSites && loggedInAccountSites.length > 0) {
    //   this._model.siteId = loggedInAccountSites[0].siteId;
    // }
    if (this._model && this._model.site) {
      this._loadSitesAndInitDD(true, this._model.site);
    }
    else {
      this._loadSitesAndInitDD();
    }

  }
  //#region Get Settings Data
  GetAssetPoPreferenceSettings() {
    this._assetPoPreferencesService.getAssetPOPreference()

      .subscribe((data) => {
        if (data) {
          this._assetPoPreferencesSettings = data;
        }
      });
  }
  //#endregion
  async LoadQuantityFormats() {
    this.quantityFormat =
      await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(
      this.quantityFormat
    );
  }

  _closePurchaseOrder() {
    this._assetPurchaseOrderService
      .closePurchaseOrder(this._model.id)

      .subscribe(() => {
        this._closeForm();
      });
  }
  _submitPurchaseOrder() {
    this._assetPurchaseOrderService
      .submitPurchaseOrder(this._model.id)

      .subscribe(() => {
        this._closeForm();
      });
  }
  _approveOrRejectPurchaseOrder(isReject: boolean) {
    this._assetPurchaseOrderService
      .approveOrRejectPurchaseOrder(this._model.id, isReject)

      .subscribe(() => {
        this._closeForm();
      });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }
  _initForm() {

    this._form = this._fb.group({
      vendor: [this._model?.vendor ?? null, Validators.required],
      address: [this._model?.address ?? null, this.getLabel('LBL_AddressName')?.isRequired ? Validators.required : null],
      fundingSource: [this._model?.fundingSource ?? null,
      this.getLabel('LBL_FundingSource')?.isRequired && this._fundingSourceSettingsEnabled ? Validators.required : null],

      account: [
        (this._model?.site && this._model?.site?.account) ?? null,
        Validators.required,
      ],
      site: [this._model?.site ?? null, Validators.required],
      closed: [this._model?.closed ? this._model.closed.toString() : 'false'],
      entryDate: [
        this._model?.entryDate ? parseDate(this._model.entryDate) : new Date(),
        Validators.required,
      ],
      poNumber: [this._pageState == PageState.EDIT || this._pageState == PageState.VIEW ? this._model?.poNumber : null, Validators.required],
      dueDate: [this._model?.dueDate ? parseDate(this._model.dueDate) : null,
      this.getLabel('LBL_DueDate')?.isRequired ? Validators.required : null],
      expectedDeliveryDate: [
        this._model?.expectedDeliveryDate
          ? parseDate(this._model.expectedDeliveryDate)
          : null,
        this.getLabel('LBL_ExpectedDeliveryDate')?.isRequired ? Validators.required : null
      ],
      subtotal: [this._model?.subtotal ? this._model.subtotal : 0],
      shipping: [this._model?.shipping ? this._model.shipping : 0],
      discount: [this._model?.discount ? this._model.discount : 0],
      otherAdjustment: [this._model?.otherAdjustment ? this._model.otherAdjustment : 0],
      tax: [this._model?.tax ? this._model.tax : 0],
      total: [this._model?.total ? this._model.total : 0],
    });

  }
  //#region Settings
  GetFundingSourceSettings() {
    this._fundingSourceSettingService.getFundingSourceSettings().subscribe((data) => {
      this._fundingSourceSettingsEnabled = data && data.enabled ? true : false;
    });
  }

  //#endregion
  //#region Dropdowns
  loadDropDowns() {
    //this._loadVendorsDropDown();
    this._loadModels();
    //this._loadAddressesFromSiteShiptoAddress();
    this._loadFundingSource();
  }
  _loadVendorsDropDown(siteId: any = null) {
    // return this._vendorsService
    //   .getVendorsListingWithEntityAddress()
    //   .subscribe((data: any) => {
    //     this._vendors = data;
    //     this._vendorsFiltered = data;
    //   });
    return this._vendorsService.getVendorsListing(null, siteId).subscribe((data: any) => {
      this._vendors = data;
      this._vendorsFiltered = data;
      this._handleVendorsChange(data, false);
    });
  }

  _loadModels(siteId: any = null) {
    return this._assetModelService.getAssetModelListing(null, siteId).subscribe((data: any) => {
      this._models = [...data.body.data];
      this._modelsFiltered = [...data.body.data];
    });
  }

  _loadAddressesFromSiteShiptoAddress(siteId: any = null) {
    return this._siteShipToAddress.getSiteShipToAddress(null, siteId).subscribe((data: any) => {
      this._addresses = [];

      if (data && data.body) {
        data.body.forEach((element: any) => {
          this._addresses.push(element.address);
        });
      }

      this._addressesFiltered = [...new Map(this._addresses.map(item => [item['id'], item])).values()];
    });
  }

  _loadFundingSource() {
    return this._fundingSourceService.getFundingSourceListing().subscribe((data: any) => {
      this._fundingSources = data;
      this._fundingSourcesFiltered = data;
    });
  }

  //#endregion
  //#region Dialog Actions
  _openForm(componentName: string) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', fileSource: fileSources.assetPurchaseOrder };
  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm(model: any = null) {
    this.reloadlist = this._sharedService.model.reload;
    var closeComponent = {
      component: 'asset-purchaseOrders',
      isClosed: true,
      response: this.reloadlist === undefined ? null : model
      // response: null,
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('asset-purchaseOrders');
    this._layoutManager.setFromChanged('asset-purchaseOrders');
    this.ngOnDestroy();
    //this._purchaseOrdersService.purchaseOrdersFormClosed(this._form.get('poNumber').value ?? '');
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    if (model) {
      closeComponent.response = model;
      this._dataService.push(closeComponent);
      this._sharedService.model = {};
    }
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;

    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  _closeDialog(event: boolean) {
    this._isDialiog = false;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
    this._initForm();
  }
  //#endregion

  //#region Expand And Collapse Actions
  ExpandCollapseScanInventoryWidget(isExpand: boolean) {
    this.isScanInventoryExpanded = !isExpand;
  }

  ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
    this.isGeneralInformationExpanded = !isExpand;
  }

  //#endregion
  _edit(): void {
    this._pageState = PageState.EDIT;
  }

  //#region Security Actions
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization[]) => {
      this._gridFieldAuth = x;
    });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }
      return result ? result : new GridFieldAuthorization();
    }
  }

  async loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      //this._initForm();
    });
  }

  //#endregion
  getLabel(objectCode: string): GridFieldTextSummary {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }

      return result ? result : null;
    }
  }

  //#region Vendor DropDown Actions
  _handleVendorsFilter(value: any) {
    this._vendorsFiltered = this._vendors.filter((s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleVendorsChange(value: any, ToggleAddress: boolean = true) {
    if (value) {
      setTimeout(() => {
        this._selectedVendorId = value.id;
        if (this.vendorAddressTextarea)
          this.vendorAddressTextarea.nativeElement.value = this._fillAddressDetails(value);
        if (this.kendoComboAddresses) {
          if (ToggleAddress) {
            this.kendoComboAddresses.toggle();
            this.kendoComboAddresses.focus();
          }
        }
      });
    }
    else {
      if (this.vendorAddressTextarea?.nativeElement) {
        this.vendorAddressTextarea.nativeElement.value = '';
      }
    }
  }

  _fillAddressDetails(value: any) {
    var addressDetails = '';

    if (value != null) {
      value = (value.entityAddress == null) ? value : value.entityAddress;
      if (value.addressLine1 != null && value.addressLine1 != '') {
        addressDetails += value.addressLine1;
      }

      if (value.addressLine2 != null && value.addressLine2 != '') {
        addressDetails += '\n' + value.addressLine2;
      }

      if (value.city != null && value.city != '') {
        addressDetails += '\n' + value.city;
      }

      if (value.state != null && value.state != '') {
        if (value.city != null && value.city != '') {
          addressDetails += ' ' + value.state;
        }
        else {
          addressDetails += '\n' + value.state;
        }
      }

      if (value.zip != null && value.zip != '') {
        if (value.state != null && value.state != '') {
          addressDetails += ' ' + value.zip;
        }
        else {
          addressDetails += '\n' + value.zip;
        }
      }

      if (value.country != null && value.country != '') {
        addressDetails += '\n' + value.country;
      }
    }

    return addressDetails;
  }

  _getVendorsGridData = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._vendorsService.getVendors(params, model, this._form.controls['site'].value?.id);
  };

  _closeVendorsWindow(): void {
    this._showVendorsGrid = false;

    this._gridFields.getGridFieldsByPage('vendors').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('vendors', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('vendors', (gridColumns) => {
      this._vendorsGridColumns = gridColumns;
    }));

    this._currentUser = this._securityService.currentUser;
  }

  _onVendorRowSelectionChanges(e: any[]) {
    this._selectedVendors = [];
    e.forEach((item) => {
      this._selectedVendors.push(item);
    });
  }

  _returnSelectedVendorHandler(e: any[]): void {
    this._showVendorsGrid = false;
    this._form.patchValue({
      vendor: this._selectedVendors[0],
    });

    if (this._selectedVendors[0] !== undefined && this._selectedVendors[0] !== null) {
      this._selectedVendorId = this._selectedVendors[0].id;
      this.vendorAddressTextarea.nativeElement.value = this._fillAddressDetails(this._selectedVendors[0]);

    }
  }

  _selectVendorsHandler(): void {
    this._showVendorsGrid = true;
  }

  //#endregion Vendor DropDown Actions
  //#region  Site Ship To Address DropDown Actions
  _handleAddressesChange(value: any) {
    if (value) {
      setTimeout(() => {
        this._selectedAddressId = value.id;
        if (this.addressTextarea?.nativeElement) {
          this.addressTextarea.nativeElement.value = this._fillAddressDetails(value); // common function in Vendor DropDown Actions Region
        }

        if (this.poInput?.nativeElement) {
          this.poInput.nativeElement.focus();
        }

        if (this.kendoComboAddresses) {
          this.kendoComboAddresses.toggle(false);
        }
      });
    }
    else {
      if (this.addressTextarea?.nativeElement) {
        this.addressTextarea.nativeElement.value = '';
      }
    }

    setTimeout(() => {
      if (this.kendoComboAddresses)
        this.kendoComboAddresses.toggle(false);
    });
  }

  _handleAddressesFilter(value: any) {
    this._addressesFiltered = this._addresses.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  //#region Model # Dropdown Actions
  _handleModelsFilter(value: any) {
    this._modelsFiltered = this._models.filter((s) => s.number.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleModelsChange(value: any) {
    // this._selectedModelItemId = value.id;
    if (value != null) {
      if (this._selectedModelItem.value && this._selectedModelItem.value.modelInfo && !this._defaultUnitCost.value) {
        this._unitCost.setValue(this._selectedModelItem.value.modelInfo.cost)
      }

      setTimeout(() => {
        if (this._defaultQuantity.value) {
          this.fillGrid();
        }
        else {
          this.quantityInput.focus();
        }
      });
    }
  }

  _getModelsGridData = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._assetModelService.getAssetModelGrid(params, model, this._form.controls['site'].value?.id);
  };

  _closeModelsWindow(): void {
    this._showModelsGrid = false;
    this._gridFields.getGridFieldsByPage('asset-models').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('asset-models', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('asset-models', (gridColumns) => {
      this._modelsGridColumns = gridColumns;
    }));

    this._currentUser = this._securityService.currentUser;
  }

  _onModelRowSelectionChanges(e: any[]) {
    this._selectedModels = [];
    e.forEach((item) => {
      this._selectedModels.push(item);
    });
  }

  _returnSelectedModelHandler(e: any[]): void {
    this._showModelsGrid = false;

    if (this._selectedModels && this._selectedModels.length > 0) {
      this._selectedModels.forEach((element: any) => {
        this._selectedModelItem.setValue(element);
        this.fillGrid();
      });
      //this._handleModelsChange(this._selectedModels[0])
    }
  }

  _selectModelsHandler(): void {
    this._showModelsGrid = true;
  }
  //#endregion

  //#region Funding Source Dropdown Actions
  _handleFundingSourcesFilter(value: any) {
    this._fundingSourcesFiltered = this._fundingSources.filter(
      (s) => s.fundingSourceId.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleFundingSourcesChange(value: any) {
    if (value) {
      this._selectedFundingSourceId = value.id;
    }
  }

  _getFundingSourceGridData = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._fundingSourceService.getFundingSourceGrid(params, model);
  };

  _closeFundingSourcesWindow(): void {
    this._showFundingSourceGrid = false;

    this._gridFields.getGridFieldsByPage('fundingsource').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('fundingsource', data);
    });

    this.registerSubscription(
      this._gridLayoutManagerService.subscribeToColumnsChanges('fundingsource', (gridColumns) => {
        this._fundingSourcesGridColumns = gridColumns;
      }));

    this._currentUser = this._securityService.currentUser;
  }

  _onFundingSourcesRowSelectionChanges(e: any[]) {
    this._selectedFundingSources = [];
    e.forEach((item) => {
      this._selectedFundingSources.push(item);
    });
  }

  _returnSelectedFundingSourcesHandler(e: any[]): void {
    this._showFundingSourceGrid = false;
    this._form.patchValue({
      fundingSource: this._selectedFundingSources[0],
    });

    if (this._selectedFundingSources[0] !== undefined && this._selectedFundingSources[0] !== null) {
      this._handleFundingSourcesChange(this._selectedFundingSources[0])
    }
  }

  _selectFundingSourcesHandler(): void {
    this._showFundingSourceGrid = true;
  }
  //#endregion





  //#region Generate Barcode
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }

  private runGenerateBarcode() {
    let counter = 1;

    this.generateBarcode(counter).subscribe((data: any) => {
      // this._poNumber.setValue(data.result.toString());
      this._form.patchValue({ poNumber: data.result.toString() });

      setTimeout(() => {
        this.kendoComboModels.toggle();
        this.kendoComboModels.focus();
      });
    });
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('asset-purchaseOrders', quantity);
  }

  poNumberChanged() {
    if (this._form.controls['poNumber'].value) {
      this.kendoComboModels.toggle();
      this.kendoComboModels.focus();
    }
  }
  //#endregion
  //#region Grid Actions
  _quantitySubmited(FromOrderQuantityOrUnitCost: number) { // 1: Order Quantity 2: Unit Cost
    if (FromOrderQuantityOrUnitCost == 1) {
      if (this._selectedModelItem.value) {
        this.fillGrid();
      }
      else {
        setTimeout(() => {
          this.kendoComboModels.toggle();
          this.kendoComboModels.focus();
        });
      }
    }

    if (FromOrderQuantityOrUnitCost == 2) {
      if (this._selectedModelItem.value && this._defaultQuantity.value) {
        this.fillGrid();
      }
      else {
        if (!this._selectedModelItem.value) {
          setTimeout(() => {
            this.kendoComboModels.toggle();
            this.kendoComboModels.focus();
          });
        }
        else if (!this._defaultQuantity.value) {
          if (!this._quantity.value) {
            setTimeout(() => {
              this.unitCostInput.blur();
              this.quantityInput.focus();
            });
          }
          else {
            this.fillGrid();
          }
        }
      }
    }
  }

  private fillGrid() {
    let modelId = 0;
    let model = this._selectedModelItem.value;
    modelId = model.id;
    let gridItem = this._modelsGridData.find((x: any) => x.modelNumber === model.number);

    // Validate quantity and cost when the preference is enabled
    if (this._assetPoPreferencesSettings?.alertWhenEnableMakeModelQuantiyAndCostRequired == true) {
      const quantity = this._quantity.value;
      const unitCost = this._unitCost.value;

      if (!quantity || +quantity <= 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Model "' + model.number + '" could not be added. Please fill in the Order Quantity.',
          withoutConfirm: true,
        });
        return;
      }

      if (unitCost == null || unitCost < 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Model "' + model.number + '" could not be added. Please fill in the Unit Cost.',
          withoutConfirm: true,
        });
        return;
      }
    }

    if (gridItem) {
      this._modelsGridData = this._modelsGridData.filter((x: any) => x.modelNumber != gridItem.modelNumber);
      this._layoutComponent.openPopup({
        title: 'Validation',
        message:
          'Duplicate model is found. The old entry has been removed.',
        returnAfterOkCloseClick: true,
        withoutConfirm: true,
      });
    }

    this._modelsGridData.push({
      modelId: model.id,
      id: 0,
      assetPurchaseOrderId: 0,
      quantityReceived: 0,
      backorderQty: 0,
      modelNumber: model.number,
      modelName: model.name,
      quantity: this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : (this._quantity.value ? this._quantity.value : 0),
      unitCost: this._defaultUnitCost.value ? (this._unitCost.value ? +this._unitCost.value : 0) : (this._unitCost.value ? this._unitCost.value : 0),
      extendedCost:
        (this._unitCost.value ?? 0) *
        (this._quantity.value ? +this._quantity.value : 1),
      isTaxable: false,
    });

    this._selectedModelItem.setValue(null);

    if (!this._defaultQuantity.value) {
      this._quantity.setValue(null);
    }

    if (!this._defaultUnitCost.value) {
      this._unitCost.setValue(null);
    }

    setTimeout(() => {
      this.kendoComboModels.toggle();
      this.kendoComboModels.focus();
    });

    this._updateGridFooterValues();
    //   .getAssetModelById(modelId)
    //   
    //   .subscribe((data) => {
    //     // if (gridItem) {
    //     //   this._modelsGridData = this._modelsGridData.filter(
    //     //     (x: any) => x.itemNumber != gridItem.itemNumber
    //     //   );
    //     //   this._layoutComponent.openPopup({
    //     //     title: 'Validation',
    //     //     message:
    //     //       'Duplicate model is found. The old entry has been removed.',
    //     //     returnAfterOkCloseClick: true,
    //     //     withoutConfirm: true,
    //     //   });
    //     // }

    //     // this._modelsGridData.push({
    //     //   modelId: data.id,
    //     //   id: 0,
    //     //   assetPurchaseOrderId: 0,
    //     //   quantityReceived: 0,
    //     //   backorderQty: 0,
    //     //   modelNumber: data.number,
    //     //   modelName: data.name,
    //     //   quantity: this._quantity.value ? +this._quantity.value : 0,
    //     //   unitCost: this._unitCost.value ?? 0,
    //     //   extendedCost:
    //     //     (this._unitCost.value ?? 0) *
    //     //     (this._quantity.value ? +this._quantity.value : 1),
    //     //   isTaxable: false,
    //     // });
    //     // this._selectedModelItem.setValue(null);
    //     // this._quantity.setValue(null);
    //     // this._unitCost.setValue(null);

    //     // setTimeout(() => {
    //     //   this.kendoComboModels.toggle();
    //     //   this.kendoComboModels.focus();
    //     // });

    //     // this._updateGridFooterValues();
    //   });
  }

  _removeHandler({ sender, dataItem }: any) {
    this._modelsGridData = this._modelsGridData.filter((x: any) => x.modelNumber != dataItem.modelNumber);
    this._updateGridFooterValues();
  }
  //#endregion

  //#region Print Actions
  _showPrintWindow() {
    if (this._form.controls['site'].value) {
      this._reportService.ReportsByCategoryName('asset-purchaseOrders', true, this._form.controls['site'].value.id).subscribe(
        (x: any) => {
          this.assetPurchaseOrderReports = x;
          this.showReports = true;
        });
    }
    else if (this.isLoggedInAllSites) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please, Select Site Code',
        withoutConfirm: true
      });
    }
  }

  _printReceiptReport() {
    var reportId = this.selectReceiptReport.value.id;
    this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.EDIT, { reportId: reportId, transactionId: this._model.id });
    // this._onClear();
  }

  _closePrintForm() {
    this.showReports = false;
  }
  //#endregion

  //#region Calculations Actions

  _updateGridFooterValues() {
    this._subtotal = this._modelsGridData.reduce((sum: any, current: any) => sum + current.extendedCost, 0);
    this._total =
      this._subtotal +
      this._shipping -
      this._discount -
      this._otherAdjustment +
      this._tax;
  }

  _onOrderQuantityChange(e: any, item: any) {
    item.quantity = e;
    item.extendedCost = e * item.unitCost;
    //if(item.quantityReceived > 0){
    //item.backorderQty =  item.quantity - item.quantityReceived;
    //}
    this._updateGridFooterValues();
  }

  _onUnitCostChange(e: any, item: any) {
    item.unitCost = e;
    item.extendedCost = e * item.quantity;

    this._updateGridFooterValues();
  }

  _onUnitsReceivedChange(e: any, item: any) {
    item.quantityReceived = e;
    item.backorderQty = item.quantity - e;

    this._updateGridFooterValues();
  }

  _onShippingChange(e: any) {
    this._shipping = e;
    this._updateGridFooterValues();
  }

  _onDiscountChange(e: any) {
    this._discount = e;
    this._updateGridFooterValues();
  }

  _onOtherAdjustmentChange(e: any) {
    this._otherAdjustment = e;
    this._updateGridFooterValues();
  }

  _onTaxChange(e: any) {
    this._tax = e;
    this._updateGridFooterValues();
  }

  _calculateBackOrderQty() {
    if (this._modelsGridData) {
      this._modelsGridData.forEach((item: any) => {
        item.backorderQty = (item.quantity ? item.quantity : 0) - (item.quantityReceived ? item.quantityReceived : 0);
      });
    }

  }
  //#endregion

  // #region Fields Tab Containers
  getCustomForm(event: any) {
    this._customForm = event;
  }

  _onTabSelect(e: SelectEvent): void {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }

  getFormTabs() {
    try {
      this._gridFields.getformTabsByPage(this._page).subscribe((x: FormTabSummary[]) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
    } catch { }
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: GridFieldSummary[]) => {
      this._systemFields = [...x];
      this._editedSystemFields = [...x];
      /* this._systemFields.forEach((s:GridFieldSummary, indx: number) =>{
        this._tabDisabledIndexes.push(indx);
      }) */
      this.loadCustomFields(this._model?.id?.toString());
    })
  }

  private loadCustomFields(entityId?: string) {
    //this._pacer.start();
    this._customFieldsService.getCustomFields(this._entity, this._page).subscribe((data) => {
      data = data.filter(x => x.formTab?.page == this._page);
      if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
        let that = this;
        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }
      var tabIds = data.map((item) => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
      let that = this;
      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};
        grouped.forEach(element => {
          element.forEach((value: any) => {

            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }
          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);
        });
      }

      this.setMandatoryFields();
    });
    //this._pacer.start()
    this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
      //get custom tabs first
      this._customTabs = data.filter(
        (x: { isCustom: boolean }) => x.isCustom == true
      );
    });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }

  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];

    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element: { isCustomField: any; formTab: any; formTabId: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);

            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      if (this.screenTabs) {
        let tabElementList = this.screenTabs.nativeElement.querySelector('ul');

        Array.from(tabElementList.children).forEach((child: any) => {
          child.classList.remove('mendatoryTab');
        });

        Array.from(tabElementList.children).forEach((child: any) => {
          if (this._requiredFieldNames.find((x: { name: any; page: string; formtab: { page: string; }; }) => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }

          if (this.requiredSystemTabs.find((x: any) => x.name === child.firstChild.innerText)) {
            child.classList.add('mendatoryTab');
          }
        });
      }

      this._requiredFields.forEach((element: { isCustomField: any; formTab: { name: any; }; customFieldsData: any[]; name: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }

        if (element.customFieldsData != undefined) {
          let thisvalue = element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0
            ? element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value
            : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == this._page ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
      if (response != null && response['message'] != null) {
        var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
        this._dataTabs.splice(this._dataTabs.indexOf(deletedTab), 1);
        //go to zero based tab
        this.screenTabStrip.selectTab(0);
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
          });
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: response['message'],
          withoutConfirm: true
        });
        if (response['close'] != null) {
          if (response['close'] == true) {

          } else {
            return;
          }
        }
      }

    });

  }
  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }
  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    //this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }
  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }
  // #endregion
  // #region Custom Fields / Forms Actions
  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }
  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _onEditForms() {
    this._isEditForms = true;
  }
  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _viewInactiveFields() {
    this._getInactiveFields();
    /* this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)
      
      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      }); */
    this._deactivatedFieldsForm = true;
  }
  _reactivateField(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            this.getSystemFieldsAndCustomFields();
            this._deactivatedFieldsForm = false;
            //get tabid,if not in list call get systemtabs
            var deletedTab = this._dataTabs.find(f => f.id == item.formTabId && f.isCustom == true);
            if (deletedTab == undefined) {
              this.getFormTabs();
            }
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              /* if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                } else {
                  return;
                }
              } */
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    /* this.getSystemFieldsAndCustomFields();
    this._customFieldsService
    .getDeactivatedCustomFields(this._entity,this._page)
    
    .subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    }); */
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }
  dataMove(newLocData: any, oldLocData: any, dataTab?: FormTabSummary) {
    const sysF: GridFieldSummary[] = this._systemFields.filter(f => f.formTabId == dataTab.id);
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });
    sysF.find((x: { id: any; }) => x.id === oldLocData.id).formOrder =
      sysFClone.find((x) => x.id === newLocData.id).formOrder;
    sysF.find((x: { id: any; }) => x.id === newLocData.id).formOrder =
      sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = sysF;
  }
  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields).subscribe((x: GridFieldSummary[]) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    if (this._customFieldsValue == undefined) { this._customFieldsValue = []; }
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });

  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          return;
        }
      }
    }
  }
  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  _getInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
  }
  // #endregion
  //#region Transactions Field Editor
  onShowTransactionFieldEditor(objectCode: string) {
    this._showTransactionFieldEditor = true;
    this._transactionsFieldEditorObjectCode = objectCode;
  }
  onCloseTransactionFieldEditor() {
    this._showTransactionFieldEditor = false;
  }
  //#endregion
  //#region Save Actions
  _onSave(event: string) {
    this._addPurchaseOrder(event);
  }
  _addPurchaseOrder(e: any, fileIds?: number[]) {
    if (!this._form.controls['vendor'].value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please, select a vendor.',
        withoutConfirm: true
      });
      return false;
    }
    if ((this._modelsGridData && this._modelsGridData.length <= 0) || !this._modelsGridData) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please, add items to create the Purchase Order.',
        withoutConfirm: true
      });
      return false;
    }

    if (this._assetPoPreferencesSettings?.alertWhenEnableMakeModelQuantiyAndCostRequired == true) {
      var CheckQuantityInModelsGrid = this._modelsGridData.find((x: any) => x.quantity <= 0 || !x.quantity);

      if (CheckQuantityInModelsGrid) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please, fill the quantity for Model #: ' + CheckQuantityInModelsGrid.modelNumber,
          withoutConfirm: true
        });

        return false;
      }

      var CheckUnitCostInModelsGrid = this._modelsGridData.find((x: any) => x.unitCost == null || x.unitCost < 0);

      if (CheckUnitCostInModelsGrid) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please, fill the unit cost for Model #: ' + CheckUnitCostInModelsGrid.modelNumber,
          withoutConfirm: true
        });

        return false;
      }
    }

    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    else if (this._form.controls['vendor']
      && this._form.controls['vendor'].value) {


      // work with custom fields
      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }
      this._invalidForm = false;
      this._invalidSubmit = false;
      const formModel = this._form.value;
      let model: any = {};

      if (this._model != null && this._model.id != null) {
        model['id'] = this._model.id;
      }

      model['customFieldsValue'] = this._customFieldsDictionary;
      model['closed'] = formModel.closed == 'true' ? true : false;
      model['poNumber'] = formModel.poNumber;
      model['entryDate'] = formModel.entryDate;
      model['dueDate'] = formModel.dueDate;
      model['expectedDeliveryDate'] = formModel.expectedDeliveryDate;
      model['siteId'] = formModel.site.id;
      model['vendorId'] = (formModel.vendor == null) ? null : formModel.vendor.id;
      model['fundingSourceId'] = (formModel.fundingSource == null) ? null : formModel.fundingSource.id;
      model['addressId'] = (formModel.address == null) ? null : ((formModel.address.id == -1) ? null : formModel.address.id);
      model['siteId'] = (formModel.site == null) ? null : formModel.site.id;
      //model['siteId'] = this._siteSelected?.id;
      model['assetPurchaseOrderDetails'] = this._modelsGridData.map((x: any) => {
        return {
          id: x.id,
          modelId: x.modelId,
          quantity: Number(x.quantity)?.toFixed(this.digitNumber),
          unitCost: x.unitCost,
          extendedCost: x.extendedCost,
          isTaxable: x.isTaxable,
          quantityReceived: x.quantityReceived

        };
      });
      model['subtotal'] = this._subtotal;
      model['shipping'] = this._shipping;
      model['discount'] = this._discount;
      model['otherAdjustment'] = this._otherAdjustment;
      model['tax'] = this._tax;
      model['total'] = this._total;

      let _transactionFiles: IAssetPurchaseOrderFilesDto[] = [];
      _transactionFiles.push(...this._purchaseOrderFilesPics);
      _transactionFiles.push(...this._purchaseOrderFilesDoc);
      _transactionFiles.push(...this._purchaseOrderFilesVideo);
      if (model['assetPurchaseOrderFiles'] == undefined) {
        model['assetPurchaseOrderFiles'] = [];
      }
      _transactionFiles.forEach((v) => {
        let item: any = {};
        item.fileid = v.fileId;
        item.assetPurchaseOrderId = v.assetPurchaseOrderId
        model['assetPurchaseOrderFiles'].push(item);
      })
      if (this._pageState == PageState.EDIT) {
        // model.closed = false;
        this._assetPurchaseOrderService
          .updatePurchaseOrder(this._model.id, model)

          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'Purchase Order updated successfully.',
              withoutConfirm: true
            });
            this._assetPurchaseOrderService.purchaseOrderUpdated.emit(model);
            this._calculateBackOrderQty();
            if (e === 'saveAndClose') {
              this._closeForm();
            }
            else if (e === 'saveAndCopy') {
              this._form.controls.poNumber.setValue(null);
              this._pageState = PageState.ADD;
            }
            else if (e === 'saveAndNew') {
              this.openUpsert(this._page, {}, PageState.ADD);
            }
            else if (e === 'saveAndPrint') {
              this._model = response;
              this._showPrintWindow();
            }
            else if (e === 'save') {
              this._model = response;
              this.getdata(true);
            }


          });
      } else {

        this._assetPurchaseOrderService
          .createPurchaseOrder(model)

          .subscribe((response: any) => {
            this.note.createNote(parseInt(response?.id));
            model.id = response?.id;
            this._assetPurchaseOrderService.purchaseOrderAdded.emit(model);
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'Purchase Order created successfully.',
              withoutConfirm: true
            });
            this._calculateBackOrderQty();
            if (e === 'saveAndClose') {
              this._closeForm(model);
            }
            else if (e === 'saveAndCopy') {
              this._form.controls.poNumber.setValue(null);
            }
            else if (e === 'saveAndNew') {
              this.openUpsert(this._page, {}, PageState.ADD);
            }
            else if (e === 'saveAndPrint') {
              this._pageState = PageState.EDIT;
              this._model = response;
              this._showPrintWindow();
              this.getdata(true);
            }
            else {
              this._pageState = PageState.EDIT;
              this._model = response;
              this.getdata(true);

            }
          });
      }

    }

  }
  _getSelectedDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  }
  _onDocumentRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }

  _onDocumentbjectRowSelectionChanges(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  //#endregion

  // #region File Library
  //Images / Picutres
  _getFilesGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._filesPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._filesPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._filesPageName, (gridColumns) => {
      this._filesGridFields = gridColumns;
    });
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please, choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._filesGridFields == undefined || this._filesGridFields.length == 0) {
        this._getFilesGridFields();
      }
      this._showImagesGrid = true;
    }
  }
  _closeImagesWindow(): void {
    this._showImagesGrid = false;
    this._isDialiog = false;
  }
  _returnSelectedImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showImagesGrid = false;
        this._selectedImagesKeys = this._selectedImages;
        this._addPicture();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please, choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = false;
      this._selectedImagesKeys = this._selectedImages;
      this._addPicture();
    }
  }
  _addPicture(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesPics =
        this._purchaseOrderFilesPics === null ? [] : this._purchaseOrderFilesPics;
      if (this._selectedObjectImages.length > 0) {
        this._selectedObjectImages.forEach((element: any) => {
          let exists = this._purchaseOrderFilesPics.find(f => f.fileId == element.id);
          if (exists == undefined) {
            delete element.fileAccounts;
            let addedFileItem: IAssetPurchaseOrderFilesDto = <IAssetPurchaseOrderFilesDto>({
              fileId: element.id,
              file: element,
              assetPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesPics.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: IAssetPurchaseOrderFilesDto = <IAssetPurchaseOrderFilesDto>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        assetPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesPics.push(addedFileItem);
    }
  }
  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }
  _onImageObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    this._selectedObjectImages = e;
  }
  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(
      this._selectedAccountIds,
      params,
      model
    );
  };
  _setPrimaryPic(data: any) {
    this._purchaseOrderFilesPics.forEach((element: IAssetPurchaseOrderFilesDto) => {
      if (element !== data) {
        element.isPrimary = false;
      }
      else {
        element.isPrimary = true;
      }
    });
  }
  _removePicHandler(event: any) {
    const index = this._purchaseOrderFilesPics.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesPics.splice(index, 1);
      this._selectedImagesKeys.splice(this._selectedImagesKeys.indexOf(event), 1);
    }
  }
  _removeFileFromLibrary(event: IAssetPurchaseOrderFilesDto) {
    //Delete Logic Goes Here
    this._removePicHandler(event);

  }
  _onSelectedImagesChanged(e: any[]) {
  }
  _onSelectedImagesRowChanged(e: any[]) {
  }
  //Documents
  _getDocumentsGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._documentsPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._documentsPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._documentsPageName, (gridColumns) => {
      this._documentsGridFields = gridColumns;
    });
  }
  _selectDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please, choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._documentsGridFields == undefined || this._documentsGridFields.length == 0) {
        this._getDocumentsGridFields();
      }
      this._showDocumentsGrid = true;
    }
  }
  _closeDocumentsWindow(): void {
    this._showDocumentsGrid = false;
  }
  _returnSelectedDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = false;
        this._selectedDocumentsKeys = this._selectedDocuments;
        this._addDocument();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please, choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      this._selectedDocumentsKeys = this._selectedDocuments;
      this._addDocument();
    }
  }
  _addDocument(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesDoc =
        this._purchaseOrderFilesDoc === null ? [] : this._purchaseOrderFilesDoc;

      if (this._selectedObjectDocuments.length > 0) {
        this._selectedObjectDocuments.forEach((element: any) => {
          let exists = this._purchaseOrderFilesDoc.find(f => f.fileId == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: IAssetPurchaseOrderFilesDto = <IAssetPurchaseOrderFilesDto>({
              fileId: element.id,
              file: element,
              assetPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesDoc.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: IAssetPurchaseOrderFilesDto = <IAssetPurchaseOrderFilesDto>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        assetPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesDoc.push(addedFileItem);
    }
  }
  _removeDocHandler(event: any) {
    const index = this._purchaseOrderFilesDoc.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesDoc.splice(index, 1);
      this._selectedDocumentsKeys.splice(this._selectedDocumentsKeys.indexOf(event), 1);
    }
  }
  _onDocumentsRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }
  _onDocumentObjectRowSelectionChange(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getDocuments(params, model);
  };
  _doDownloadFile(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);

  }
  //Videos
  _getVideosGridFields() {
    if (this._filesGridFieldsSub) this._filesGridFieldsSub.unsubscribe();
    this._gridFields
      .getGridFieldsByPage(this._videosPageName)

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects(this._videosPageName, data);
      });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._videosPageName, (gridColumns) => {
      this._videosGridFields = gridColumns;
    });
  }
  _selectVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please, choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      if (this._videosGridFields == undefined || this._videosGridFields.length == 0) {
        this._getVideosGridFields();
      }
      this._showVideoGrid = true;
    }
  }
  _closeVideosWindow(): void {
    this._showVideoGrid = false;
  }
  _returnSelectedVideosHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showVideoGrid = false;
        this._selectedVideosKeys = this._selectedVideos;
        this._addVideo();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please, choose the account with the site desired',
          withoutConfirm: true
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showVideoGrid = false;
      this._selectedVideosKeys = this._selectedVideos;
      this._addVideo();
    }
  }
  _addVideo(fileData: any = null) {
    if (fileData == null) {
      this._purchaseOrderFilesVideo =
        this._purchaseOrderFilesVideo === null ? [] : this._purchaseOrderFilesVideo;

      if (this._selectedObjectVideos.length > 0) {
        this._selectedObjectVideos.forEach((element: any) => {
          let exists = this._purchaseOrderFilesVideo.find(f => f.fileId == element.id && f.status == EntityStatusOptions.Active);
          if (exists == undefined) {
            let addedFileItem: IAssetPurchaseOrderFilesDto = <IAssetPurchaseOrderFilesDto>({
              fileId: element.id,
              file: element,
              assetPurchaseOrderId: this._model.id ? this._model.id : 0,
              status: EntityStatusOptions.Active,
            });
            this._purchaseOrderFilesVideo.push(addedFileItem);
          }
        });
      }
    }
    else {
      let addedFileItem: IAssetPurchaseOrderFilesDto = <IAssetPurchaseOrderFilesDto>({
        fileId: fileData.response.id,
        file: fileData.picObject.file,
        assetPurchaseOrderId: this._model.id ? this._model.id : 0,
        status: EntityStatusOptions.Active,
      });
      this._purchaseOrderFilesVideo.push(addedFileItem);
    }
  }
  _removeVideoHandler(event: any) {
    const index = this._purchaseOrderFilesVideo.indexOf(event, 0);
    if (index > -1) {
      this._purchaseOrderFilesVideo.splice(index, 1);
      this._selectedVideosKeys.splice(this._selectedVideosKeys.indexOf(event), 1);
    }
  }
  _onVideosRowSelectionChanges(e: any[]) {
    this._selectedVideos = [];
    e.forEach((item) => {
      this._selectedVideos.push(+item);
    });
  }
  _onVideoObjectRowSelectionChange(e: any[]) {
    this._selectedObjectVideos = [];
    this._selectedObjectVideos = e;
  }
  _getAccountVideos = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getVideos(params, model);
  };
  _doDownloadVideo(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);
  }
  // #endregion
  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;
      this.initAllSitesDropDown(IsEdit, SavedSite);
    });
  }

  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this._form.controls['site'].setValue(this._siteSelected);
    this._loadVendorsDropDown(this._form.controls['site'].value?.id);
    this._loadModels(this._form.controls['site'].value?.id);
    this._loadAddressesFromSiteShiptoAddress(this._form.controls['site'].value?.id);
  }

  // _handleSitesChange(event: any)
  // {
  //   this._siteSelected = event;
  //   //this._loadLocationsDD(this._siteSelected?.id);
  //   this._loadVendorsDD(this._siteSelected?.id);
  //   this.getStockItemDDPaging();
  // }
  _handleSitesChange(event: any) {
    let _currentVal = this._form.value.site;

    setTimeout(() => {
      if (this._modelsGridData.length > 0 || this._form.controls['vendor'].value || this._form.controls['address'].value) {
        if (confirmSiteSub) {
          confirmSiteSub.unsubscribe();
        }

        var confirmSiteSub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
          if (data == true) {
            this._modelsGridData = [];
            this._form.controls['vendor'].setValue(null);
            this._form.controls['address'].setValue(null);
            this._selectedModelItem.setValue(null);
            this._siteSelected = event;
            this._form.controls['site'].setValue(event);

            this._loadVendorsDropDown(this._form.controls['site'].value?.id);
            this._loadModels(this._form.controls['site'].value?.id);
            this._loadAddressesFromSiteShiptoAddress(this._form.controls['site'].value?.id);
          }
          else {
            this._form.patchValue({
              site: _currentVal
            });
          }
        });

        this._layoutComponent.openPopup({
          title: 'Notification',
          message: `Changing the site will clear the selected items,vendor,address of the transaction. Continue?`
        });
      }
      else {
        this._form.controls['vendor'].setValue(null);
        this._form.controls['address'].setValue(null);
        this._selectedModelItem.setValue(null);
        this._siteSelected = event;
        this._form.controls['site'].setValue(event);
        this._loadVendorsDropDown(this._form.controls['site'].value?.id);
        this._loadModels(this._form.controls['site'].value?.id);
        this._loadAddressesFromSiteShiptoAddress(this._form.controls['site'].value?.id);
      }
    }, 100);
  }
  //#endregion


  //#region File Notes
  _showVendorNotesWindow(id: number) {
    this._vendorsService.getVendor(id).subscribe((model: any) => {
      this._vendorNotesModel = model;
      this._showVendorFileNotes = true;
    });
  }

  _closeVendorNotesWindow() {
    this._showVendorFileNotes = false;
  }

  _closeModelNotesWindow() {
    this._showModelFileNotes = false;
  }

  _showModelNotesWindow(id: number) {
    this._assetModelService.getAssetModelById(id).subscribe((model: any) => {
      this._modelNotesModel = model;
      this._showModelFileNotes = true;
    });
  }
  //#endregion

  displayModelImage(input: string, ListOfItems: any = null) {
    let primaryPicture;

    if (ListOfItems != null && ListOfItems.length > 0) {
      primaryPicture = ListOfItems.find((v: any) => v.modelFileisPrimary == true);

      if (primaryPicture == undefined && primaryPicture == null) {
        primaryPicture = ListOfItems[0];
      }

      input = primaryPicture.file.thumbnail;

      return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
    }
    else return '';
  }
}
